module.exports = __webpack_public_path__ + "img/it_it.6b621317.png";